import Vue from 'vue';
import VueTheMask from 'vue-the-mask';
import Toasted from 'vue-toasted';

// Локали moment переехали в modules/profile/section/accounts — единственное
// место, где moment вообще используется. Отсюда они тянули весь moment
// (685 КБ несжатого) в стартовый бандл каждой страницы сайта.

//use
Vue.use(Toasted, {
    duration: 3000
});
Vue.use(VueTheMask);
